import { useState, useEffect } from "react";
import { FetchProviders } from "../../api/FetchProviders";
import { ProvidersDataInfo } from "../../helpers/interfaces/ProvidersInterfaces";

const default_page_size = 10;

const _data: ProvidersDataInfo | any = {
  meta: {
    page: 1,
    limit: default_page_size,
  },
  data: [],
};

export const useFetchProviders = (query: {
  page: number;
  limit: number;
  search_value?: string;
}) => {
  const [dataInfo, setDataInfo] = useState(_data);

  useEffect(() => {
    const fetchData = async () => {
      const result = await FetchProviders(query);

      if (result?.data?.data) {
        for (const item of result.data.data) {
          item["key"] = item.provider_id;
        }
      }

      setDataInfo(result);
    };

    fetchData();
  }, [query]);

  return dataInfo;
};
